import React from 'react';

export const renderMultilineText = (
  text = '',
  maxLines = 2,
  maxCharsPerLine = Infinity,
) => {
  const words = `${text}`.split(' ');
  const lines = [];
  let currentLine = '';

  // Construye las líneas
  words.forEach(word => {
    if (lines.length >= maxLines) return;

    const wouldExceed = (currentLine + ' ' + word).length > maxCharsPerLine;

    if (wouldExceed) {
      if (lines.length < maxLines - 1) {
        lines.push(currentLine);
        currentLine = word;
      } else {
        // Última línea - truncar si es necesario
        const remainingSpace = maxCharsPerLine - currentLine.length - 1;
        currentLine +=
          remainingSpace > 0 ? ` ${word.slice(0, remainingSpace)}...` : '...';
      }
    } else {
      currentLine = currentLine ? `${currentLine} ${word}` : word;
    }
  });

  if (currentLine && lines.length < maxLines) lines.push(currentLine);

  return lines;
};

export const MultilineText = ({ text, maxLines, maxCharsPerLine }) => {
  const lines = renderMultilineText(text, maxLines, maxCharsPerLine);

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {lines.map(line => (
        <span key={line}>{line}</span>
      ))}
    </div>
  );
};
